export default __webpack_public_path__ + "static/media/rnr-sports-table-4.df34d661.webp";